import React, { useState } from 'react'
import { useQuery } from 'react-query'
import { USER_LIST_COLUMNS as ucol } from '../../../constants/userConstants'
import { Table, Space, Button, message, ConfigProvider } from 'antd'
import axios from '../../../utils/AxiosUtil'
import { useHistory } from 'react-router-dom';
import { axiosPostAndHint, modalHint } from '../../../components/reqAndHint'
import AsyncSwitch from '../../../components/AsycSwitch'
import zhCN from 'antd/es/locale/zh_CN';
import { useSelector } from 'react-redux'
export default function UserListTable(props) {
    let history = useHistory();
    const [pageSize, setPageSize] = useState();
    const langValue = useSelector(state => state.langList.value)
    let operCol = {
        title: '操作',
        en_title: 'Operation',
        ch_title: '操作',
        key: "操作",
        width: '90px',
        render: (text, record, index) => {
            return (<Space size='small'>
                <Button type="link" onClick={() => {
                    history.push(`/view/user/update/${record.key}`);
                }}>{langValue == 0 ? '编辑Edit' : (langValue == 1 ? '编辑' : 'Edit')}</Button>
            </Space>);
        }
    };

    let columns = [...ucol, operCol];
    //状态用开关组件渲染
    columns[4].render = (text, record, index) => {
        let checked = record['状态'] == 'on';
        let rcd = record;

        //和组件在同一上下文
        function handleSwitchClick(checked, record) {
            return new Promise((resolve, reject) => {
                axios.post('/fund/user/updateStatusByUid', { uid: record['key'], userStatus: checked ? "on" : "off" })
                    .then((data) => {
                        // console.log('*********axios data:', data);
                        record['状态'] = checked ? "on" : "off";
                        message.destroy();
                        message.info(langValue == 0 ? <>更新用户状态成功<br />Successfully updated user status</> : (langValue == 1 ? '更新用户状态成功' : 'Successfully updated user status'));
                        resolve(checked);
                    }).catch(e => {
                        //组件应及时恢复原状态,和成功相反，逆向操作
                        //
                        // console.log('*********axios e:', e, e.response.data);
                        record['状态'] = !checked ? "on" : "off"; "on";
                        const { msg, en_msg } = e ?.response ?.data
                        message.destroy();
                        message.error(langValue == 0 ? <>更新用户状态失败：{msg}<br />Failed to update user status:{en_msg}</> : (langValue == 1 ? `更新用户状态失败：${msg}` : `Failed to update user status:${en_msg}`));
                        reject(!checked);
                    });
            })
        }

        return (<div>
            <AsyncSwitch checked={checked} handleClick={
                (checked) => handleSwitchClick(checked, rcd)
            } />
        </div>);
    }
    const getColumns = (col) => {
        let newCol = [...col];
        // console.log(newCol);
        newCol.forEach((c, i) => {
            if (i == 3) {
                c.render = (_, item) => {
                    return langValue == 0 ? <span>{item['职称']}<br />{item.en_role_name}</span> : (langValue == 1 ? item['职称'] : item.en_role_name)
                }
            }
            c.title = langValue == 0 ? <>{c.ch_title}<br />{c.en_title}</> : (langValue == 1 ? c.ch_title : c.en_title)
        })
        return newCol;
    }
    const { userStatus, roleId, nameOrAccount } = props;

    // console.log('User react query ......');
    const { data, isLoading, isError, isFetching, error, status } =
        useQuery(['userList', userStatus, roleId, nameOrAccount],
            () => axios.post('/fund/user/list', { userStatus, roleId, nameOrAccount })
                .catch(e => {
                    // console.log("*****e******");
                    return e;
                }), { refetchOnWindowFocus: false }
        );
    if (isLoading) {
        // console.log("user loading .....")
        return <div>{langValue == 0 ? '加载中LOADING' : (langValue == 1 ? '加载中' : 'LOADING')}</div>
    } else if (error) {
        // console.log('user isError');
        return <div>加载出错，{error}</div>
    } else {
        if (data.response) {
            // console.log("出错了:", data.response.data);
            return <div>加载出错，{data.response.data.msg}</div>;
        }
        // console.log("user data.data is :", data.data);
        let dataSrc = [...data.data.data];
        dataSrc.forEach((d, i) => { d['序号'] = i + 1 });
        return (<div className='user-table-container'>
            <ConfigProvider locale={zhCN}>
                <Table
                    sticky
                    columns={getColumns(columns)}
                    dataSource={dataSrc}
                    pagination={{
                        pageSizeOptions: [10, 20, 50, 100, 1000],
                        pageSize: pageSize,
                        showQuickJumper: true,
                        showSizeChanger: true,//可选每页条数，数据少时仍展示
                        onChange: (page, pageSize) => setPageSize(pageSize),
                    }}
                ></Table>
            </ConfigProvider>
        </div>);
    }



}
